import { useGlobal } from '@/utils/useGlobal';
import { Collapse } from 'antd';
import FAQ from '../FAQ';
import Manuals from '../Manuals';
import QuoteForm from '../QuoteForm';
import Tutorial from '../Tutorial';
import css from './index.module.scss';
import { useRouter } from 'next/router';
import { AIChatIcon } from './icon';
import gtm from '@/utils/gtm';

const pages = ['/delta-pro-ultra-x', '/smart-gateway', '/smart-home-panel-3'];

export default function Folder({ activeForm, setActiveForm, supportData = {}, active, callFolder, theme, spuId, hasForm }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('shared.product.support');
    const { downloadList = [], videoList = [], faqList = [], onlineList = [] } = supportData;
    const manualList = [...downloadList?.filter((list: any) => list?.classify === 'MANUAL'), ...onlineList];
    const showFAQ = faqList?.length > 0;
    const showVideo = videoList?.length > 0;
    const showManuals = manualList?.length > 0;
    const { locale = 'us', pathname } = useRouter();
    const items: any[] = [];
    if (showFAQ) items.push({ key: 'faq', value: t('faq') });
    if (hasForm) items.push({ key: 'form', value: pathname === '/delta-pro-3-portable-power-station' && locale === 'jp' ? t('form1') : t('form') });
    if (showVideo) items.push({ key: 'tutorial', value: t('tutorial') });
    if (showManuals) items.push({ key: 'manuals', value: t('downloads') });

    const collapseLists: any[] = [];
    if (showFAQ) collapseLists.push({ key: 'faq', value: t('faq') });
    if (hasForm) collapseLists.push({ key: 'form', value: pathname === '/delta-pro-3-portable-power-station' && locale === 'jp' ? t('form1') : t('form') });
    if (showVideo) collapseLists.push({ key: 'tutorial', value: t('tutorial') });
    if (showManuals) collapseLists.push({ key: 'manuals', value: t('downloads') });

    const handleOpenChat = () => {
        try {
            (window as any).Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();
            gtm.push({
                event: 'uaEvent',
                event_name: 'get_support',
                button_name: t('ai-link'),
            });
        } catch (error) {}
    };

    return (
        <section className={`product-support-folder ${css['product-support-folder']} ${theme}`}>
            <ul className="folder-menus pc">
                {items?.map((item: any, k: number) => (
                    <li className={`folder-item ${active === item?.key ? 'active' : ''}`} key={k} onClick={() => callFolder(item?.key)}>
                        {item?.value}
                    </li>
                ))}
            </ul>
            <Collapse
                ghost={true}
                className="collapse-lists-folder h5"
                defaultActiveKey={collapseLists?.findIndex((list: any) => list.key === active) || 0}
                onChange={(a) => {
                    setActiveForm(a);
                }}
                // accordion={true}
                activeKey={activeForm}
                expandIcon={({ isActive }: any) => {
                    return (
                        <svg
                            className={`collapse-icon ${isActive ? 'active' : ''}`}
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                        >
                            <path
                                d="M17.5 15L12.5 10L7.5 15"
                                stroke={theme === 'white' ? 'black' : 'white'}
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    );
                }}
                expandIconPosition="right"
            >
                {collapseLists?.map((list: any, k: number) => (
                    <Collapse.Panel className="list-title" key={k} header={list.value}>
                        {list?.key === 'faq' ? (
                            <FAQ faqList={faqList} theme={theme} spuId={spuId} />
                        ) : list?.key === 'form' ? (
                            <QuoteForm />
                        ) : list?.key === 'tutorial' ? (
                            <Tutorial videoList={videoList} theme={theme} />
                        ) : (
                            <Manuals manualList={manualList} theme={theme} />
                        )}
                    </Collapse.Panel>
                ))}
            </Collapse>
            {pages.includes(pathname) && (
                <div className="ai-chat">
                    <div className="ai-inner">
                        <div className="chat-icon">{AIChatIcon}</div>
                        <p className="ai-title">{t('ai-title')}</p>
                        <p className="ai-desc">{t('ai-desc')}</p>
                        <p className="ai-link" onClick={handleOpenChat}>
                            {t('ai-link')}
                        </p>
                    </div>
                </div>
            )}
        </section>
    );
}
